import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { DeleteOffer, GetOffers } from '../../fetchs';
import { Link } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AlertDialog from '../Prompt/alert-dialog.component';
import CircularProgress from '@material-ui/core/CircularProgress';

import './offer-list.styles.css';

const headCells = [
  { id: 'offerType', numeric: false, disablePadding: true, label: 'نوع تخفیف' },
  { id: 'value', numeric: false, disablePadding: true, label: 'مقدار' },
  { id: 'jalaliValidFrom', numeric: false, disablePadding: true, label: 'از تاریخ' },
  { id: 'jalaliValidTo', numeric: false, disablePadding: true, label: 'تا تاریخ' },
  { id: 'validCount', numeric: false, disablePadding: true, label: 'تعداد مجاز استفاده ' },
  { id: 'usedCount', numeric: true, disablePadding: false, label: 'تعداد دفعات استفاده شده' },
  { id: 'tools', numeric: false, disablePadding: true, label: '' }
];

export default class OfferList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      rowsPerPage: 20,
      rowsLength: 0,
      rows: [],
      alertDialog: false,
      deleteId: null,
      loading: false,
    }
  }

  componentDidMount() {
    this.getOffers();
  }

  getOffers = () => {
    this.setState({ loading: true });

    GetOffers(this.state.page * this.state.rowsPerPage, this.state.rowsPerPage)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      }).then(responseJson => {
        this.setState({ rows: responseJson.data, rowsLength: responseJson.count });
      }).catch(error => {
        this.setState({ loading: false });
        console.error(error);
      })
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getOffers();
    });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      this.getOffers();
    });
  }

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteOffer(this.state.deleteId)
      .then(response => {
        this.setState({ loading: false });
        if (response.status === 200)
          this.getOffers();
        return response.json();
      })
      .then(responseJson => {

      })
      .catch(error => {
        console.error(error);
      })
  }

  handlePrepareDelete = (id) => {
    this.setState({ deleteId: id, alertDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  }

  emptyRows = () => this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.rowsLength - this.state.page * this.state.rowsPerPage);

  render() {
    return (
      <div className="root">
        <Paper className="paper">
          <Toolbar>
            <Grid item xs={12} sm={4}>
              <div className="title">
                {(
                  <Typography variant="h6" id="tableTitle">
                    لیست تخفیف ها
                </Typography>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={6}></Grid>
            <Grid item xs={12} sm={2}>
              <Link to="/main/offer" className="link">
                <Button variant="contained" color="primary">ساخت تخفیف جدید</Button>
              </Link>
            </Grid>
          </Toolbar>
          <div className="tableWrapper">
            <Table
              className="table"
              aria-labelledby="tableTitle"
              size={'medium'}
            >
              <TableHead>
                <TableRow>
                  {headCells.map(headCell => (
                    <TableCell
                      key={headCell.id}
                      align={'center'}
                      padding={headCell.disablePadding ? 'none' : 'default'}
                    >
                      <TableSortLabel
                        active={false}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.rows.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                    >
                      <TableCell align="center">{row.offerType === 1 ? "درصدی" : "مقدار"}</TableCell>
                      <TableCell align="center">{row.value}</TableCell>
                      <TableCell align="center">{row.jalaliValidFrom}</TableCell>
                      <TableCell align="center">{row.jalaliValidTo}</TableCell>
                      <TableCell align="center">{row.validCount}</TableCell>
                      <TableCell align="center">{row.usedCount}</TableCell>
                      <TableCell align="center" style={{ width: '105px' }}>
                        <Link to={`/main/offer/${row.offerId}`}>
                          <EditIcon color="primary" />
                        </Link>
                        <DeleteIcon
                          className="deleteIcon"
                          onClick={() => this.handlePrepareDelete(row.offerId)} />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {this.emptyRows > 0 && (
                  <TableRow style={{ height: 49 * this.emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          {this.state.loading && <CircularProgress size={24} className="buttonProgress" />}
          <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={this.state.rowsLength}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            backIconButtonProps={{
              'aria-label': 'previous page',
            }}
            nextIconButtonProps={{
              'aria-label': 'next page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        <AlertDialog
          open={this.state.alertDialog}
          title={`اخطار`}
          body={`آیا از حذف تخفیف اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog} />
      </div>
    )
  };
}